const menuTrigger = document.querySelector('.js-menuTrigger')
const navigation = document.querySelector('.js-navigation')
const subMenuTriggers = [...document.querySelectorAll('.js-subMenuTrigger')]

if (menuTrigger) {
	menuTrigger.addEventListener('click', () => {
	    navigation.classList.toggle('-opened')
	    menuTrigger.classList.toggle('-close')
	})
}

subMenuTriggers.forEach(subMenuTrigger => {
    subMenuTrigger.addEventListener('click', () => {
        const submenuId = subMenuTrigger.dataset.submenu
        const subMenu = document.querySelector(`.js-subMenu[data-submenu="${submenuId}"]`)

        subMenuTrigger.classList.toggle('-opened')
        subMenu.classList.toggle('-opened')
    })
})
